// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"633":"068d5c59","966":"74a5bbb4"}[chunkId] + ".css";
};